/** The dial link for a phone number as typed: digits and `+` only. */
export function telHref(phone: string): string {
  return `tel:${phone.replace(/[^\d+]/g, '')}`;
}
